import React from 'react';
import moment from 'moment';

const TimeSelect = ( {neverDisable, input, values, activeDate }) => {
  let defaultTime  = activeDate ? moment(activeDate, 'YYYY/MM/DD HH:mm:ss').format('HH:mm')  : '00:00';

  const timeOptions = []
   for (var i = 0; i < 24; i++) {
    const time = moment(i, ' H').format("HH:mm:ss");
    const timeToDisplay = moment(i, ' H').format("HH:mm");
    timeOptions.push(<option key={time} value={time}>{timeToDisplay}</option>)
  }

  return(
    <div className="custom-control"  >
      <div className="">
      <select {...input} disabled={!neverDisable && values !== "option2"} >
        <option value="00:00:00" hidden="hidden" defaultValue={defaultTime}>{defaultTime}</option>
        {timeOptions}
      </select>
    </div>
    </div>
  )
}
export default TimeSelect;



// WEBPACK FOOTER //
// ./src/lib/forms/TimeSelect.js